module.exports = __webpack_public_path__ + "static/media/loader.f01cb46f.svg";